import { CustomLoader } from '@/components/elements/loader';
import { BasketBlocks } from '@/components/modules/basket-page/basket-blocks';
import { TVariantsCreditProducts } from '@/components/modules/caclulator/types';
import { useAppSelector } from '@/store/hooks';

import { TRentProduct, PopularProducts } from '@/entities/product';

import { useTranslate } from '@/shared/hooks/use-translate';
import { Heading } from '@/shared/ui/heading';
import { Layout } from '@/shared/ui/layout';
import { PageSection } from '@/shared/ui/page-section';

import { StyledBasketPageModuleLoader } from './styled';

type TBasketPageModuleProps = {
    popularProducts: TRentProduct[];
    variantsCreditProducts: TVariantsCreditProducts;
};

export const BasketPageModule: React.FC<TBasketPageModuleProps> = ({ popularProducts, variantsCreditProducts }) => {
    const { itemsBasket, isLoaded } = useAppSelector((state) => state.basket);

    const { t } = useTranslate();

    return (
        <Layout.Content>
            <Heading as="h1">{t('Корзина')}</Heading>
            {!isLoaded ? (
                <StyledBasketPageModuleLoader>
                    <CustomLoader />
                </StyledBasketPageModuleLoader>
            ) : (
                <BasketBlocks products={itemsBasket} variantsCreditProducts={variantsCreditProducts} />
            )}
            {itemsBasket.length === 0 && isLoaded && (
                <PageSection title={t('Самые популярные 🔥')}>
                    <PopularProducts products={popularProducts} />
                </PageSection>
            )}
        </Layout.Content>
    );
};
